import { render, staticRenderFns } from "./CommonMetatagList.vue?vue&type=template&id=74769ac4&scoped=true&"
import script from "./CommonMetatagList.vue?vue&type=script&lang=js&"
export * from "./CommonMetatagList.vue?vue&type=script&lang=js&"
import style0 from "./CommonMetatagList.vue?vue&type=style&index=0&id=74769ac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74769ac4",
  null
  
)

export default component.exports